import CustomDropDawnTree from 'components/customDropDawntree/CustomDropDawnTree'
import { useFormik } from 'formik'
import InputSelect from 'global/InputSelect/InputSelect'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import CustomSwitch from 'global/Switch/Switch'
import { SelectResponseSchema } from 'models/globalModels'
import { convertSubZoneResponse } from 'pages/determain-geographic-areas/utils'
import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAPI } from 'services/CRUDServices'
import { getUrls, selectUrls } from 'services/api.enums'
import { findNode } from 'tools/functions/Methods'
import ZoneLists from './table'
import { ActionSidebar } from 'redux/optime/optime'
import { setCurrentHub } from 'redux/CurrentHub/CurrentHubReducer'
import { activeAddZone, setAreaType } from 'redux/customGeo/customGeoReducer'

interface SearchFormProps {
  // setSearchData: React.Dispatch<any>
  // setSelectedPolygon: React.Dispatch<any>
  setSelectedPolygons: React.Dispatch<any>
  polygons: any
  response: any
  getZoneInfo: any
  selectedHub: any
  setSelectedHub: any
}
const SearchForm: FC<SearchFormProps> = ({
  // setSearchData,
  // setSelectedPolygon,
  setSelectedPolygons,
  polygons,
  response,
  getZoneInfo,
  selectedHub,
  setSelectedHub,
}) => {
  const [zoneOption, setZoneOption] = useState<any>([])
  const { addZone } = useSelector((state: any) => state.customGeo)
  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo)
  const currentHubInfo = useSelector((state: any) => state.currentHubInfo)
  const [treeChecked, setTreeChecked] = useState<Array<string>>([])
  const [subzonesArea, setSubzonesArea] = useState<Array<any>>([])
  const [initialSubZone, setInitialSubZone] = useState<Array<any>>([])
  const [selectedState, setselectedState] = useState<Array<any>>([])
  const [selectEditZoneArea, setselectEditZoneArea] = useState<any>(null)
  const { areaType } = useSelector((state: any) => state.customGeo)

  const userInfo = useSelector((state: any) => state.userInfo)
  const dispatch = useDispatch()
  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      selectHub: '',
      countrytype: {},
    } as any,
    onSubmit: () => {
      getZoneInfo()
    },
  })
  useEffect(() => {
    setInitialSubZone(response)

    response && areaType
      ? setSubzonesArea(
          response.filter((area) => area.countryType.id === areaType)
        )
      : setSubzonesArea(response)
  }, [response])

  async function handleChangeType(value) {
    dispatch(setAreaType(value.id))
    if (value.id) {
      const filter = initialSubZone.filter(
        (area) => area.countryType.id === value.id
      )
      setSubzonesArea(filter)
    } else {
      setSubzonesArea(initialSubZone)
    }

    const res = await getAPI(
      getUrls.countryDevisionFindbyhub +
        `?code=${selectedHub.value}&hubid=${
          CurrentHub?.id
          // findNode({ children: userInfo?.hublist }, selectedHub.value).id
        }`
    )
    const sub = res.data.payload.map((item) => convertSubZoneResponse(item))
    const main = [polygons.shift()]
    if (value.id){
      const filterPolygons = sub.filter(
        (area) => area.countryType.id === value.id
      )
      setSelectedPolygons([...main, ...filterPolygons])
    }
    else{
      setSelectedPolygons([...main, ...sub])
    }


  }

  useEffect(() => {
    getAPI(selectUrls.countrytype).then((res) => {
      setZoneOption(
        res.data.payload.filter((item: SelectResponseSchema) => item.id > 2)
      )
    })
  }, [])

  useEffect(() => {
    if (currentHubInfo?.CurrentHub?.value) {
      setTreeChecked([currentHubInfo?.CurrentHub?.value])
      setSelectedHub(currentHubInfo?.CurrentHub)
    }
  }, [currentHubInfo?.CurrentHub])

  // useEffect(() => {
  //   // let polygone =
  //   //   selectedState &&
  //   //   selectedState[0]?.polygone.map((value: any) => {
  //   //     return [value.locLong, value.locLate];
  //   //   });
  //   // const currentState = selectedState.at(-1);
  //   // selectedState.length !== 0 &&
  //   //   setSelectedPolygon({ ...currentState, polygone: polygone });
  // }, [selectedState])

  return (
    <div className='flex w-full h-full gap-5'>
      <div className='w-full h-full flex flex-col items-start gap-5'>
        <div className='flex flex-col gap-4 w-full z-50'>
          <CustomDropDawnTree
            noCascade
            valueNodeChecked={selectedHub}
            classWrapper='autocompleteWrapper'
            nodes={userInfo?.hublist ? userInfo?.hublist : []}
            loadingNode={false}
            title='هاب '
            // treeCheckedError={treeCheckedError}
            holeClassWrapper='h-[274px]'
            treeChecked={treeChecked}
            setTreeChecked={setTreeChecked}
            nodeChecked={(value) => {
              setTreeChecked([value.value])
              // formik.setFieldValue("countrytype",{})
              setSelectedHub(
                findNode({ children: userInfo?.hublist }, value.value)
              )
              dispatch(
                setCurrentHub(
                  findNode({ children: userInfo?.hublist }, value.value)
                )
              )
              // getZoneInfo()
            }}
          />
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className='flex flex-col gap-4 w-full'
        >
          <div className='flex w-full gap-3'>
            <div className='w-[50%] flex justify-center items-center'>
              <InputSelect
                isClearable
                wrapperClassName='w-full mt-6'
                name='countrytype'
                label='نوع منطقه'
                values={formik.values.countrytype}
                handleChange={(name: string, value: object) => {
                  formik.setFieldValue(name, value)
                  handleChangeType(value)
                }}
                options={zoneOption}
              />
            </div>
            <div className='w-[40%] flex justify-center items-center'>
              <span className='whitespace-nowrap'>وضعیت :</span>
              <CustomSwitch
                wrapperClassName='w-full justify-center '
                active={formik.values.isActive}
                handleChange={(checked: any) =>
                  formik.setFieldValue('isActive', checked)
                }
              />
            </div>
          </div>
          {/* <SimpleButton
            searchBtn
            className='w-full full-gray-btn my-[15px]'
            text='جستجو'
          /> */}
        </form>
        <SimpleButton
          className={`${
            addZone ? 'opacity-100' : ' opacity-60 '
          } full-tomato-btn w-full`}
          text='افزودن'
          handelClick={() => dispatch(activeAddZone(!addZone))}
        />

        {subzonesArea && (
          <ZoneLists
            subzonesArea={subzonesArea}
            selectedState={selectedState}
            setselectedState={setselectedState}
            selectEditZoneArea={selectEditZoneArea}
            setselectEditZoneArea={setselectEditZoneArea}
            getZoneInfo={getZoneInfo}
          />
        )}
      </div>
    </div>
  )
}

export default SearchForm

